import { useRef } from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Packages from "@/components/landing/Packages";
import Addons from "@/components/landing/Addons";
import Steps from "@/components/landing/Steps";
import QuoteForm from "@/components/landing/QuoteForm";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  const quoteRef = useRef(null);

  const goToQuote = (preselect) => {
    quoteRef.current?.scrollIntoView(preselect);
  };

  return (
    <div className="min-h-screen bg-brand-base text-brand-ink">
      <Header onQuote={() => goToQuote()} />
      <main>
        <Hero onCheck={() => goToQuote()} />
        <Packages onBook={(name) => goToQuote(name)} />
        <Addons />
        <Steps />
        <QuoteForm ref={quoteRef} />
      </main>
      <Footer />
    </div>
  );
}
